import React from "react";
import Header from "@/components/Header";
import SavingsCard from "@/components/SavingsCard";
import { usePeriod } from "@/contexts/PeriodContext";

export default function SavingsPage() {
  const { month, year, view, setMonth, setYear, setView } = usePeriod();
  return (
    <div className="min-h-screen">
      <Header
        month={month}
        year={year}
        view={view}
        setMonth={setMonth}
        setYear={setYear}
        setView={setView}
        showFilters={false}
        title="חסכונות"
        backTo="/app"
      />
      <main className="max-w-6xl mx-auto px-4 md:px-8 py-8">
        <SavingsCard />
      </main>
    </div>
  );
}
